import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import MizzyDevice from "../MizzyDevice";
import ComplexVoice from "../Voices/ComplexVoice";

var Vincent =
/*#__PURE__*/
function (_MizzyDevice) {
  _inherits(Vincent, _MizzyDevice);

  function Vincent(context, count) {
    var _this;

    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "sawtooth";
    var wideness = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;

    _classCallCheck(this, Vincent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Vincent).call(this, context));
    _this.oscillatorType = type;
    _this.numberOfOscillators = count;
    _this._wideness = wideness;
    return _this;
  }

  _createClass(Vincent, [{
    key: "NoteOn",
    value: function NoteOn(MidiEvent) {
      var voice = new ComplexVoice(this.context, this.oscillatorType, this.numberOfOscillators);
      voice.init();
      voice.attack = this.attack;
      voice.decay = this.decay;
      voice.sustain = this.sustain;
      voice.release = this.release;
      voice.connect(this.effectInput);
      voice.on(MidiEvent);
      this.voices[MidiEvent.value] = voice;
    }
  }, {
    key: "wideness",
    set: function set(value) {
      var _this2 = this;

      this._wideness = value;
      this.voices.forEach(function (voice) {
        return voice.wideness = _this2._wideness;
      });
    },
    get: function get() {
      return this._wideness;
    }
  }, {
    key: "type",
    set: function set(value) {}
  }]);

  return Vincent;
}(MizzyDevice);

export { Vincent as default };